import { Link } from "react-router-dom";

export function PricingItemCard({ item, t }) {
    return (
        <div className="col-lg-4">
            <div
                className={`pricing-item background-pricing-item d-flex flex-column justify-content-between ${item.classes} `}
            >
                <h3 className="text-dark mb-0">{t(item.translationKey)}</h3>
                <div className="icon">
                    <div className="icon">
                        <img
                            src={item.iconUrl}
                            className="img-fluid w-75"
                            alt=""
                            data-aos="zoom-out"
                            data-aos-delay="100"
                        />
                    </div>
                </div>
                <div className="text-center">
                    <Link to="/home#book" className="buy-btn">
                        {t("park.button_book")}
                    </Link>
                </div>
            </div>
        </div>
    );
}
